import styled from 'styled-components';

import { COLORS, ACQ, GRADIENTS, MOBILE } from '../../theme/tokens';
import { Text } from '../Text/Text';

/** Responsive grid for a set of KpiTiles — two columns, one on mobile. */
export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  ${MOBILE} {
    grid-template-columns: 1fr;
  }
`;

/** The card: a #18181b surface with a 32% black wash and a hairline border. */
export const Tile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  border-radius: 16px;
  background: ${GRADIENTS.featureCard};
  box-sizing: border-box;
`;

// --- Header (title + subtitle) ----------------------------------------------
export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0 5px;
`;

export const HeadText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
`;

export const TileTitle = styled(Text)`
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  color: ${COLORS.featureName};
`;

export const TileSubtitle = styled(Text)`
  font-size: 14px;
  font-weight: 300;
  color: ${COLORS.featureName};
`;

// --- Inner stats panel (Today | This month) ---------------------------------
export const Stats = styled.div`
  display: flex;
  align-items: stretch;
  gap: 12px;
  padding: 12px;
  border-radius: 16px;
  background: ${ACQ.panel};
`;

export const Stat = styled.div<{ $align?: 'start' | 'end' }>`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: ${(p) => (p.$align === 'end' ? 'flex-end' : 'flex-start')};
  text-align: ${(p) => (p.$align === 'end' ? 'right' : 'left')};
`;

export const StatDivider = styled.div`
  flex: 0 0 1px;
  align-self: stretch;
  background: ${GRADIENTS.dividerStyledV};
`;

export const StatPeriod = styled(Text)`
  font-size: 12px;
  font-weight: 300;
  line-height: 1;
  color: ${COLORS.text};
`;

export const StatBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: inherit;
`;

export const StatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.1;
  color: ${COLORS.textStrong};
`;
